var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStreamlineIconCommonFileHorizontalImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.46973 5.66602C3.46973 5.99754 3.60142 6.31548 3.83584 6.5499C4.07026 6.78432 4.38821 6.91602 4.71973 6.91602C5.05125 6.91602 5.36919 6.78432 5.60361 6.5499C5.83803 6.31548 5.96973 5.99754 5.96973 5.66602C5.96973 5.3345 5.83803 5.01655 5.60361 4.78213C5.36919 4.54771 5.05125 4.41602 4.71973 4.41602C4.38821 4.41602 4.07026 4.54771 3.83584 4.78213C3.60142 5.01655 3.46973 5.3345 3.46973 5.66602Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4667 11.3035L10.552 6.93353C10.5012 6.85748 10.4326 6.79498 10.3521 6.75143C10.2717 6.70788 10.1818 6.68461 10.0903 6.68363C9.99886 6.68264 9.90853 6.70397 9.82716 6.74578C9.74579 6.78758 9.67584 6.84859 9.62337 6.92353L8.1267 9.06686L7.20004 8.3222C7.13917 8.27343 7.06882 8.23787 6.99347 8.21777C6.91811 8.19767 6.8394 8.19348 6.76233 8.20546C6.68527 8.21743 6.61154 8.24532 6.54584 8.28734C6.48013 8.32936 6.4239 8.38459 6.3807 8.44953L4.4707 11.3162",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 2.01563C1.23478 2.01563 0.98043 2.12098 0.792893 2.30852C0.605357 2.49605 0.5 2.75041 0.5 3.01563V12.985C0.5 13.2502 0.605357 13.5045 0.792893 13.6921C0.98043 13.8796 1.23478 13.985 1.5 13.985H14.5C14.7652 13.985 15.0196 13.8796 15.2071 13.6921C15.3946 13.5045 15.5 13.2502 15.5 12.985V4.98496C15.5 4.72416 15.3981 4.47369 15.216 4.28696L13.294 2.31696C13.2008 2.22151 13.0894 2.14568 12.9665 2.09393C12.8435 2.04217 12.7114 2.01555 12.578 2.01563H1.5Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconCommonFileHorizontalImage);
export default __webpack_public_path__ + "static/media/streamline-icon-common-file-horizontal-image.fde5d8520107c2c16f7a2c886546bad8.svg";
export { ForwardRef as ReactComponent };